import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbIconComponent, NbWindowRef, NB_WINDOW_CONTEXT } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-window-container',
  templateUrl: './window-container.component.html',
  styleUrls: ['./window-container.component.scss']
})
export class WindowContainerComponent implements OnInit, AfterViewInit {
  url:string;
  iframeUrl:SafeResourceUrl;
  componentConfig:any;
  addForm:OfbizForm;
  listForm:OfbizList;
  state$:any;

  listFieldOptions:any = {};
  listOptions:any = {};

  addOptions:any = {};
  
  addTitle:string;
  listTitle:string;
  
  showList = false;

  @ViewChild("resultsChevron", {read: ElementRef}) resultsChevron: NbIconComponent;
  @ViewChild("iframe", { static: false }) iframe!: ElementRef<HTMLIFrameElement>;
  
  constructor(
    protected windowRef: NbWindowRef,
    @Inject(NB_WINDOW_CONTEXT) data,
    private sanitizer: DomSanitizer,
   private configurationService:ConfigurationService,
  private activatedRoute:ActivatedRoute,
private renderer: Renderer2) { 
    this.activatedRoute.snapshot;
    
    //const url = this.router.serializeUrl(this.router.createUrlTree([data]));
    console.log(data,this.configurationService.getBaseUrl(),window.location.hostname,window.location.host);
    //console.log("activatedRouteStuff",{"snapShot":this.activatedRoute.snapshot,"url":this.activatedRoute.url.,"root":this.activatedRoute.root})
    //this.router.navigateByUrl(data.link, { skipLocationChange: false })
    //window.open(url, '_self');
    //console.log(data);
    /* this.componentConfig = data["context"];
    data["state"].subscribe(data => this.state$ = data);
    console.log(this.state$);
    this.addTitle = "Add "+data.componentConfig.title;
    this.listTitle = data.componentConfig.title+" List"; */
    this.url = "http://"+window.location.host+data["link"];
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    console.log(this.iframeUrl,this.url)
  }
  ngAfterViewInit(): void {
    if (this.iframe?.nativeElement) {
      this.iframe.nativeElement.onload = () => this.onIframeLoad();

      
      /* this.iframe.nativeElement.onload = () => {
        let iframeDoc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow?.document;
        if (iframeDoc) {
          let ngxAdminHeader = iframeDoc.querySelector('ngx-admin-header');
          if (ngxAdminHeader) {
            console.log('Found ngx-admin-header:', ngxAdminHeader);
          } else {
            console.warn('ngx-admin-header not found inside iframe');
          }
        }
      } */
      /* let interAppWindow = <HTMLElement>this.iframe.nativeElement.closest('.inter-app-window');
      console.log(interAppWindow)
      if(interAppWindow){
        interAppWindow.style.height = "height: 80vh"
        interAppWindow.style.width = "width: 70vw";
        let ngxAdminHeader = this.iframe.nativeElement.querySelector('ngx-admin-header');
        if (ngxAdminHeader) {
          console.log('Found ngx-admin-header:', ngxAdminHeader);
        }
      }

      let headerEl = this.iframe.nativeElement.getElementsByTagName('NGX-ADMIN-HEADER');
      if(headerEl){
        console.log(headerEl)
      } */
      
    }
    
  }
  onIframeLoad() {
    const iframeElement = this.iframe.nativeElement;
    const iframeDoc = iframeElement.contentDocument || iframeElement.contentWindow?.document;
  
    if (!iframeDoc) {
      console.error('Could not access iframe document – likely a cross-origin issue');
      return;
    }
  
    const observer = new MutationObserver(() => {
      const ngxAdminHeader = iframeDoc.querySelector('ngx-admin-header');
  
      if (ngxAdminHeader) {
        console.log('ngx-admin-header found:', ngxAdminHeader);
        observer.disconnect(); // Stop observing once the element is found
        const headerContainers = ngxAdminHeader.querySelectorAll('.header-container')
        if(headerContainers){
          const navHeaderContainer = <HTMLElement>headerContainers[1];
          navHeaderContainer.style.setProperty("display","none");
        }
        //console.log('headerContainers found:', headerContainers);
      }
    });
  
    // Start observing the body of the iframe for any changes
    observer.observe(iframeDoc.body, { childList: true, subtree: true });
  }
  

  ngOnInit(): void {
    
    /* this.addForm = new OfbizForm(this.componentConfig.addFormOptions);
    this.listForm = new OfbizList(this.componentConfig.listFormOptions);
    
    this.listFieldOptions.entityName = this.listForm.entityName;

    this.listOptions.formName = this.listForm.listFormName;
    this.listOptions.entityName = this.listForm.entityName;
    this.listOptions.formLocation = this.listForm.listFormLocation;
    this.listOptions.viewIndex = this.listForm.viewIndex;
    this.listOptions.endPoint = this.listForm.endPoint;

    this.addOptions.formName = this.addForm.formName;
    this.addOptions.entityName = this.addForm.entityName;
    this.addOptions.formLocation = this.addForm.formLocation;

    console.log(this.addForm);
    console.log(this.listForm); */
  }



  toggleIcon(){
    /* console.log("item clicked");
    this.showList = this.showList ? false:true; */

  }

}
